import { CHECK_BOX_VALUE, COMMON_MESSAGE } from '../../../constants';

export const initialState = {
  eTrackPageData: null,
  loading: false,
  isResultsFound: false, // variable for result found here
  isResultsSaved: false, // variable for result saved here
  apiSuccessResponse: {
    activate: false,
  }, // You can store the api success response here
  generateBillsInAdvancedDays: 0, // You can store the default no of days out of generate bill here
  autoApproveMoveFlag: CHECK_BOX_VALUE.no, // You can store the auto approve move flag here
  searchLimitYears: 0,
  importLimitYears: 0,
  isEntitlementDataSaved: null,
  isEntitlementDataFetched: false,
  isSalesImportResultsFound: false,
  isSalesImportGridFiltered: false,
  dataToBeUpdatedForSalesImport: [], // You can store the data to be updated here
  salesImportData: [], // You can store the Sales Import data here
  salesImportFilterData: [], // You can store the filtered data here
  salesImportIsActiveFilterData: [], // You can store the filtered data here
  saleImportTableData: [], // You can store the table data here
  salesImportFilteredData: [], // You can store the filtered data here
  orderGroupNameData: [], // You can store the order group name data here
  orderGroupData: [], // You can store the order group data here
  orderGroupName: '',
  orderGroup: '',
  importFlag: COMMON_MESSAGE.select,
  deferred: COMMON_MESSAGE.select,
  deferredFilterApplied: false,
  importFilterApplied: false,
  orderGroupFilterApplied: false,
  searchBoxValue: {
    orderGroupName: null,
    orderGroup: null,
    accountingGroup: null,
    accountingGroupCode: null,
  },
  importCheckox: false, // You can store the import checkbox value here
  deferredCheckbox: false, // You can store the Deferred checkbox value here
  isActive: CHECK_BOX_VALUE.any, // You can store the active checkbox value here
  isAccountingGroupResultsFound: false,
  accoutingGroupData: [], // You can store the Accounting Group data here
  accountingGroupFilterData: [], // You can store the Accounting Group filtered data here
  accountGroupData: [], // You can store the Account Group data here
  accountGroupCodeData: [], // You can store the Account Group Code data here
  dataToBeUpdatedForAccountingGroup: [], // You can store the data to be updated here
  accountingGroup: '',
  accountingGroupCode: '',
  resellerFlag: '',
  billFlag: '',
  selectedTab: 0,
  salesImportIsActive: COMMON_MESSAGE.any,
  isSalesImportDataSaved: false,
  isAccountingGroupDataSaved: false,
  isAccountingGroupRowEdited: false,
  isAccountingGroupDataSavedAfterUpdate: false,
  isSaveAPITriggered: false,
  errors:{                   // you can store the error message and error value 
    errorsMessage:'',
    errorValue:''
  },
  eTrackTabError:{                   // you can store the error message and error value 
    searchLimitYears:'',
    importLimitYears:''
  },
};
